module.exports = __webpack_public_path__ + "static/media/book-h2o-detail2.e874a20d.jpg";